export default "__VITE_ASSET__BPT8FH6E__"